var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container full-width"},[_c('div',{staticClass:"text-subtitle1"},[_vm._v("Comments to shoppers")]),_c('q-input',{staticClass:"bg-white",attrs:{"value":_vm.text,"placeholder":"Enter comment to shopper/rider","dense":"","outlined":""},on:{"input":_vm.onChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }